var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.95 21.28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.07 0-1.22 1.59 10.41 7.98H0v2h36.45l-10.6 8.13 1.22 1.58 13.88-10.64L27.07 0z"
  })));
};
export default SvgArrowRight;